import { Box, Divider, Grid, Typography } from "@mui/material";
import LoadingIcon from "../../../../../components/LoadingIcon";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../../../stack/environment/icons/iconExport";
import InvolvedEntityChip from "../../../controls/components/EntitiesSection/InvolvedEntityChip";

const ExecutionTypeContent = ({ step, complexMisconfiguredEntitiesByType }) => {
  return (
    <Grid item xs={12} display={"flex"} flexDirection={"column"} gap={2}>
      <Box display={"flex"} flexDirection={"row"} gap={2}>
        <SvgToIcon IconLogo={icons.executionIcon} width={"80px"} />
        <Typography variant="body2">{step?.description.Description}</Typography>
      </Box>

      <Grid>
        <Divider />
      </Grid>
      <Grid container display={"flex"} gap={1}>
        <Grid item xs={12}>
          {step?.entity_ids?.length &&
            (complexMisconfiguredEntitiesByType ? (
              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyItems={"baseline"}
                gap={1}
              >
                <Typography variant="subtitle2">Involved Entities</Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    gap: 1,
                  }}
                >
                  {Object.entries(complexMisconfiguredEntitiesByType)?.map(
                    ([type, entities]) => (
                      <Grid item key={type}>
                        <InvolvedEntityChip
                          type={type}
                          entitiesCount={entities?.length}
                          subtype={entities[0]?.subtype}
                          setSelectedEntities={null}
                          sx={{ height: "20px", padding: "4px 0" }}
                        />
                      </Grid>
                    )
                  )}
                </Box>
              </Box>
            ) : (
              <LoadingIcon size={20} />
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ExecutionTypeContent;
